import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { I18n } from "@/i18n/I18n";
import { FileTypes } from "@/types/fileTypes";
import { useState, useEffect } from "react";
import { ExpandableImage } from "./ExpandableImage";
import { VideoOutput } from "./VideoOutput";
import { File } from "@/backend/models/file";

export function FileWithDisplay(props: { file: File, hideFilePreview?: boolean }) {
  const { file, hideFilePreview } = props;
  const [fileSourceUrl, setFileSourceUrl] = useState<string | null>(null);
  const getFileSourceUrl = useGlobalStore(state => state.getFileSourceUrl);

  useEffect(() => {
    void getFileSourceUrl(file.id).then(response => {
      if (response.status === 200) {
        setFileSourceUrl(response.downloadUrl);
      }
    });
  }, [file.id]);

  if(!fileSourceUrl) {
    return <div>{I18n.get('loadingFile')}</div>;
  }

  return (
    <>
      {file.type === FileTypes.IMAGE && <ExpandableImage src={fileSourceUrl} alt={file.fileName} hideFilePreview={hideFilePreview} />}
      {file.type === FileTypes.VIDEO && <VideoOutput source={fileSourceUrl} />}
    </>
  );
}